import actions from './actions';
import actionTypes from './constants/action-types';
import reducers from './reducers';
import selectors from './selectors';
import middleware from './middleware';
import filters from './filters';
import initializers from './initializers';
import registerInterruptionPoints from './initializers/register-interruption-points';

export default {
  actions,
  actionTypes,
  reducers,
  selectors,
  middleware,
  filters,
  initializers,
};

registerInterruptionPoints();
